class levelFormat {
  static level(status) {
    switch (status) {
        case 0:
            return 'Administrador';
        case 1:
            return 'Usuário';
        case 2:
            return 'Operador';
        default:
            return 'Desconecido';
    }
  }
}

export default levelFormat;